/* eslint-disable react/prop-types */
import { Box, Card, Grid, InputLabel, styled, Typography } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { REQUIRED, UPLOAD_PROOF, UPLOAD_PROOF_SUBTEXT, UTILITY_BILL } from '../../constants';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { CommonStyles } from '../LeadGeneration/CommonStyles';
import { commonUtility } from '../LeadGeneration/UtilityFunctions';
import { LayoutStyles as classes } from './LayoutStyles';
import { AddressInformationStyles as addressInfoStyles } from '../LeadGeneration/StepOne/AddressInformationStyles';
import CustomTooltip from '../Tooltip/CustomTooltip';
import { isBundle } from '../commonCode';

const StyledCard = styled(Card)(({ theme, isActive }) => ({
  borderRadius: '12px',
  // border: '1px solid #E6E6E6',
  // background: '#FFF',

  backgroundColor: theme?.palette?.fieldsBackground?.main,
  border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
  color: `${theme?.palette?.secondary?.main} !important`,

  cursor: 'pointer',
  transition: 'all 0.3s ease',
  // maxWidth: '150px',
  height: '66px',
  //   width: '100%',
  textAlign: 'center',
  width: '30%',

  ...(isActive && {
    border: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
    // background: '#F0E8F0',
    background: theme?.palette?.billTypeCustomCardbg?.main,
  }),
}));

const EmployeeCardList = ['LUMA', 'AAA', 'Others'];

const BillTypeCustomCard = ({ handleChange }) => {
  const {
    addressInformation,
    setActiveEmploymentStatus,
    addressInformationErrors,
    productName,
    theme,
  } = useContext(LeadGenerationContext);
  const styles = CommonStyles(theme);
  const handleCardClick = (e, status) => {
    const eventDetails = {
      target: {
        name: 'utilityBill',
        value: status,
      },
    };
    handleChange(eventDetails);
  };
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} data-page="address-info">
      <Grid size={{ md: 12 }}>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'flex-end',
            width: '100%',
          }}
        >
          <InputLabel
            htmlFor="utilityBill"
            data-testid="utilityBill_id"
            aria-label={`${t('Upload Home Address Proof', {
              defaultValue: 'Upload Home Address Proof',
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            sx={[styles.label_title, ...(isBundle(productName) ? [{ marginBottom: 'none' }] : [])]}
          >
            {t(UPLOAD_PROOF, {
              defaultValue: UPLOAD_PROOF,
            })}
          </InputLabel>
          &ensp;
          {/* <span style={{ marginLeft: '10px', opacity: 1 }}> */}
          <CustomTooltip
            placement="top"
            disablePadding
            text={t(`PreviewAddressConsent`, {
              defaultValue:
                'Proof of your physical address is required to open your account, if your current home address is not available on your ID. Upload a utility bill you have received within the last 60 days that shows your name and address.',
            })}
          />
        </Box>
        {/* </span> */}
        <Typography
          component="p"
          variant="subtitle2"
          color="subtext"
          sx={{ ...classes.utilityLabelSubtext, color: theme?.palette?.primary?.main }}
        >
          {t(UPLOAD_PROOF_SUBTEXT, {
            defaultValue: UPLOAD_PROOF_SUBTEXT,
          })}
        </Typography>
      </Grid>

      <Grid
        size={{ md: 12 }}
        style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
      >
        {EmployeeCardList?.map((item) => (
          <StyledCard
            tabIndex="0"
            variant="outlined"
            onClick={(e) => handleCardClick(e, item)}
            data-testid="employmentStatus_testid"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleCardClick(e, item);
              }
            }}
            aria-label={addressInformation?.utilityBill === item ? `${item} selected` : item}
            isActive={addressInformation?.utilityBill === item}
            id="utilityBill"
            dataTestId="utilityBill_id"
            required
            value={commonUtility(addressInformation?.utilityBill)}
            inputLabelAriaLabel={`${t(UTILITY_BILL, {
              defaultValue: UTILITY_BILL,
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            label={t(UTILITY_BILL, {
              defaultValue: UTILITY_BILL,
            })}
            // handleChange={handleChange}
            selectAriaLabel={`${t('Aria Label Utility Bill', {
              defaultValue: 'Utility Bill Required Select Utility Bill dropdown menu button',
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            error={addressInformationErrors?.utilityBill}
          >
            <Box component="div" sx={classes.utilityBillcardcontent}>
              {/* <Box component="img" src={item.icon} /> */}
              <Typography color="primary" variant="subtitle1" sx={classes.utilityBillCardText}>
                {t(`${item}`)}
              </Typography>
            </Box>
          </StyledCard>
        ))}
      </Grid>
      <Box component="span" role="alert" id="utilitybill" sx={addressInfoStyles.error_message}>
        {t(addressInformationErrors?.utilityBill, {
          defaultValue: addressInformationErrors?.utilityBill,
        })}
      </Box>
    </Grid>
  );
};

export default BillTypeCustomCard;
